import { render, staticRenderFns } from "./InternalAddress.vue?vue&type=template&id=45c1a508"
import script from "./InternalAddress.vue?vue&type=script&lang=js"
export * from "./InternalAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports